(function initOverlay() {
  if (!document.querySelector('.variant-picker__overlay')) {
    const overlay = document.createElement('div');
    overlay.className = 'variant-picker__overlay';
    overlay.hidden = true;
    document.body.appendChild(overlay);
  }
})();

window.initVariantPickerDropdown = function (scope = document) {
  const overlay = document.querySelector(".variant-picker__overlay");
  if (!overlay) return;

  const setupDropdown = (optionEl) => {
    if (optionEl.dataset.initialized === "true") return;
    optionEl.dataset.initialized = "true";

    const btn = optionEl.querySelector(".variant-picker__button");
    const orig = optionEl.querySelector(".variant-picker__list-wrapper");
    const input = optionEl.querySelector('input[type="hidden"]');
    const sel = btn?.querySelector(".variant-picker__selected");
    const variantEl = optionEl.closest("variant-selects");

    if (!btn || !orig || !input || !sel) return;

    const floating = orig.cloneNode(true);
    floating.classList.add("variant-picker__list-wrapper--floating");
    floating.hidden = true;
    floating.setAttribute("aria-hidden", "true");
    document.body.appendChild(floating);

    let startY = 0, currentY = 0, dragging = false;

    const attachSwipe = () => {
      const handle = floating.querySelector(".variant-picker__drag-handle");
      if (!handle) return;

      handle.addEventListener("touchstart", (e) => {
        startY = e.touches[0].clientY;
        floating.style.transition = "none";
        dragging = true;
      }, { passive: true });

      handle.addEventListener("touchmove", (e) => {
        if (!dragging) return;
        currentY = e.touches[0].clientY;
        const deltaY = currentY - startY;
        if (deltaY > 0) floating.style.transform = `translateY(${deltaY}px)`;
      }, { passive: true });

      handle.addEventListener("touchend", () => {
        if (!dragging) return;
        dragging = false;
        const deltaY = currentY - startY;
        floating.style.transition = "transform .25s ease";
        if (deltaY > 80) {
          floating.style.transform = "translateY(100%)";
          setTimeout(() => {
            floating.hidden = true;
            floating.setAttribute("aria-hidden", "true");
            floating.style.transform = "";
            floating.style.transition = "";
            toggleDropdown(false);
          }, 250);
        } else {
          floating.style.transform = "translateY(0)";
          setTimeout(() => {
            floating.style.transform = "";
            floating.style.transition = "";
          }, 250);
        }
      });
    };

    const updateItems = (wrapper) => {
      const currentValue = input.value;
      wrapper.querySelectorAll(".variant-picker__item").forEach(i => {
        i.classList.toggle("is-active", i.dataset.value === currentValue);
        i.addEventListener("click", (e) => {
          e.stopPropagation();
          const value = i.dataset.value;
          const availabilityText = i.dataset.availabilityText || "";
          wrapper.querySelectorAll(".variant-picker__item").forEach(x => x.classList.remove("is-active"));
          i.classList.add("is-active");
          sel.innerHTML = `${value}${availabilityText ? `<span class="variant-picker__availability"> – ${availabilityText}</span>` : ""}`;
          input.value = value;
          input.dispatchEvent(new Event("change", { bubbles: true }));
          toggleDropdown(false);
          if (variantEl) {
            variantEl.updateOptions?.();
            variantEl.updateMasterId?.();
            variantEl.currentVariant
              ? (variantEl.updateVariantInput?.(), variantEl.updateURL?.(), variantEl.renderProductInfo?.())
              : variantEl.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      });
    };

    const toggleDropdown = (shouldOpen) => {
      btn.setAttribute("aria-expanded", shouldOpen);
      const isMobile = window.innerWidth <= 749;

      if (isMobile) {
        if (shouldOpen) {
          const origUl = orig.querySelector("ul");
          const floatUl = floating.querySelector("ul");
          if (origUl && floatUl) floatUl.innerHTML = origUl.innerHTML;
          floating.hidden = false;
          floating.removeAttribute("aria-hidden");
          floating.classList.add("is-open");
          overlay.hidden = false;
          document.body.classList.add("overflow-hidden-mobile");
          updateItems(floating);
          attachSwipe();
        } else {
          floating.classList.remove("is-open");
          floating.hidden = true;
          floating.setAttribute("aria-hidden", "true");
          overlay.hidden = true;
          document.body.classList.remove("overflow-hidden-mobile");
        }
      } else {
        orig.hidden = !shouldOpen;
      }
    };

    updateItems(orig);

    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const shouldOpen = btn.getAttribute("aria-expanded") !== "true";
      toggleDropdown(shouldOpen);
    });

    overlay.addEventListener("click", () => {
      toggleDropdown(false);
    });

    document.addEventListener("click", (e) => {
      if (btn.getAttribute("aria-expanded") === "true") {
        const isInside = optionEl.contains(e.target) || floating.contains(e.target) || e.target === overlay;
        if (!isInside) {
          toggleDropdown(false);
        }
      }
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth > 749) toggleDropdown(false);
    });
  };

  scope.querySelectorAll(".variant-picker--dropdown .variant-picker__option").forEach(setupDropdown);
};

function setupQuickAddIntegration() {
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.quick-add-btn')) return;
    setTimeout(() => {
      const modal = document.querySelector('quick-add-modal');
      if (modal) {
        window.initVariantPickerDropdown(modal);
      }
    }, 300);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.querySelector('variant-selects')) {
          setTimeout(() => window.initVariantPickerDropdown(node), 300);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function setupModalDropdownCleanup() {
  const waitForModal = () => {
    const modal = document.querySelector('quick-add-modal');
    if (!modal) return;

    const observer = new MutationObserver(() => {
      const isOpen = modal.classList.contains('active') || modal.querySelector('.quick-add-modal__content[aria-modal="true"]');
      if (!isOpen) {
        document.querySelectorAll('.variant-picker__list-wrapper--floating.is-open').forEach(el => {
          el.classList.remove('is-open');
          el.hidden = true;
          el.setAttribute('aria-hidden', 'true');
        });
        document.querySelectorAll('.variant-picker__button[aria-expanded="true"]').forEach(btn => btn.setAttribute('aria-expanded', 'false'));
        const overlay = document.querySelector('.variant-picker__overlay');
        if (overlay) overlay.hidden = true;
        document.body.classList.remove('overflow-hidden-mobile');
        window.initVariantPickerDropdown(document);
      }
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
      childList: true,
    });
  };

  const modalObserver = new MutationObserver(() => {
    if (document.querySelector('quick-add-modal')) {
      modalObserver.disconnect();
      waitForModal();
    }
  });

  modalObserver.observe(document.body, { childList: true, subtree: true });

  if (document.querySelector('quick-add-modal')) {
    waitForModal();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.initVariantPickerDropdown(document);
  setupQuickAddIntegration();
  setupModalDropdownCleanup();
});

document.addEventListener('shopify:section:load', () => {
  setTimeout(() => window.initVariantPickerDropdown(document), 100);
});